export const CoachIcon = () => (
  <svg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_190_4463)'>
      <path
        d='M56 28C56 43.4642 43.4642 56 28 56C12.5358 56 0 43.4642 0 28C0 12.5358 12.5358 0 28 0C43.4642 0 56 12.5358 56 28Z'
        fill='#2F37ED'
      />
      <path
        d='M55.6018 32.7214L30.1943 7.31396L27.3438 13.4061L12.7969 19.3085L27.6667 34.1783L26.6725 44.7463L19.3149 47.5781L27.7334 55.9965C27.8223 55.9974 27.9107 55.9999 28 55.9999C41.8547 55.9999 53.3571 45.9366 55.6018 32.7214Z'
        fill='#0E14A3'
      />
      <path d='M25.8057 7.31396H30.1943V45.247H25.8057V7.31396Z' fill='#FFD400' />
      <path d='M27.9551 7.31396H30.1938V45.247H27.9551V7.31396Z' fill='#FFCD4B' />
      <path d='M19.3145 43.3516H36.6846V47.5783H19.3145V43.3516Z' fill='#FFBC00' />
      <path d='M27.9551 43.3516H36.6846V47.5783H27.9551V43.3516Z' fill='#F2AF00' />
      <path
        d='M30.1807 19.3087H12.7969L8.42188 14.879L12.7969 10.4497H30.1807V19.3087Z'
        fill='#F5FAFF'
      />
      <path d='M27.9551 10.4497H30.1802V19.3087H27.9551V10.4497Z' fill='#F5FAFF' />
      <path
        d='M25.8057 21.8511H43.1895L47.5645 26.2803L43.1895 30.71H25.8057V21.8511Z'
        fill='#C5DBFF'
      />
      <path
        d='M47.564 26.2803L43.189 21.8511H27.9551V30.71H43.189L47.564 26.2803Z'
        fill='#C5DBFF'
      />
    </g>
    <defs>
      <clipPath id='clip0_190_4463'>
        <rect width='56' height='56' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
